// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes, Children, cloneElement } from 'react';

// js utilities
import cx from 'classnames';
import _ from 'lodash';

// function to validate individual values
import { validateField } from '../../../modelValidator';


export default class ToggleButton extends Component {
  static propTypes = {
      className: PropTypes.string,
      defaultValue: PropTypes.any,
      children: PropTypes.object,
      value: PropTypes.any,
      id: PropTypes.any,
      'data-id': PropTypes.string,
      disabled: PropTypes.bool,
      menuItems: PropTypes.array.isRequired,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      floatingLabelText: PropTypes.string,
      validation: PropTypes.object,
      onErrorChange: PropTypes.func
  };

  state = {
    value: null,
    errors: []
  };

  componentWillMount() {
    // determine if initial value has been fed in
    const initVal = this.props.hasOwnProperty('value') ? this.props.value :
      this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue :
      null;

    // used to keep track of mounting state updates
    const stateUpdateObj = {};

    if(!_.isNil(initVal)) {
      stateUpdateObj.value = initVal;
      const currentMenuItem = this.props.menuItems.find(menuItem => menuItem.value === initVal || menuItem.id === initVal || menuItem === initVal);
      if(!currentMenuItem) {
        console.error(`value: ${initVal} does not have corresponding menu item`); /* eslint no-console:0 */
      } else if(currentMenuItem.subElement) {
        stateUpdateObj.subElement = currentMenuItem.subElement;
      }
    }

    // handles validation state update
    this.validate(initVal, stateUpdateObj);
  }

  componentWillReceiveProps(nextProps) {
    // sync local state value
    if(this.props.value !== nextProps.value) {
      this.setState({value: nextProps.value});
      this.validate(nextProps.value, {
        value: nextProps.value
      });
    }
  }

  componentWillUnmount() {
    if(this.state.errors.length && this.props.onErrorChange) {
      this.props.onErrorChange(-1);
    }
  }

  onChange(newValue, event) {
    if(_.isNil(this.props.value)) {
      this.validate(newValue, {value: newValue});
    }
    if(this.props.onChange) {
      this.props.onChange(event, newValue);
    }
    if(this.props.onBlur) {
      this.props.onBlur(event, newValue);
    }
  }

  validate(value, additionalStateUpdate) {
    if(this.props.validation) {
      const errorsObj = {
        errors: validateField(value, this.props.validation)
      };
      if(errorsObj.errors.length !== this.state.errors.length) {
        if(this.props.onErrorChange) {
          this.props.onErrorChange(errorsObj.errors.length > this.state.errors ? 1 : -1);
        }
        this.setState(_.assign(this.state, errorsObj, additionalStateUpdate || {}));
      } else if (_.size(additionalStateUpdate)) {
        this.setState(_.assign(this.state, additionalStateUpdate));
      }
    } else if (_.size(additionalStateUpdate)) {
      this.setState(_.assign(this.state, additionalStateUpdate));
    }
  }

  render() {
    let currentMenuItem;

    const menuItems = this.props.menuItems.map((val, index) => {
      // allow for 'value' and 'id'
      const currValue = val.hasOwnProperty('value') ? val.value : val.id;
      const isCurrentMenuItem = this.state.value === currValue;

      // set current menu item outside of this scope for subElement mapping
      if(isCurrentMenuItem) {
        currentMenuItem = val;
      }

      return (
        <li key={index}
            style={{width: `${100/this.props.menuItems.length}%`}}
            className={cx('toggle noTextSelect', {active: isCurrentMenuItem})}
            data-id={val.primaryText || val.name}
            onClick={this.onChange.bind(this, currValue)}>{val.primaryText || val.name}</li>
      );
    });

    const errorTextElement = this.props.errorText && (
      <div className={'error-message'}>{this.props.errorText}</div>
    );

    // current subElement
    const subElement = currentMenuItem && this.props.children && this.props.children[currentMenuItem.subElement] || null;

     let disabledStyle = {
       'pointerEvents': 'none',
       'filter': 'grayscale(100%)',
       'opacity': 0.8
     }

    return (
      <div style={this.props.disabled ? disabledStyle: null} className={`toggle-wrapper ${this.props.className || ''}`} data-id={this.props['data-id']} tabIndex={this.props.disabled ? -1 : 0}>
        <div className='floatingLabelText' data-id={this.props.floatingLabelText}>
          {this.props.floatingLabelText}
        </div>
        <ul className={cx('toggle-container', {selected: !_.isNil(this.state.value)})}>
          {menuItems}
        </ul>
        {errorTextElement}
        {
          subElement
          &&
          <div className='subElement-container'>
            {
              Children.map(subElement, // adding isSubElement prop to child
               child => cloneElement(child, _.merge({isSubElement: true})))
            }
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_ToggleButton/index.js